/**
 * Router
 */
import React, { Fragment, useContext } from 'react';
import { Switch, Route, withRouter, useLocation } from 'react-router-dom';
import Wos from './without-sidemenu';
import Ws from './with-sidemenu';
import Can from './components/Can';
import AuthContext from './authContext';

// React
// Components
import BundleDetails from './pages/bundleDetails';
import bundleLogs from './pages/bundleLogs';
import Bundles from './pages/bundles';
import Drivers from './pages/drivers';
import DriversShift from './pages/drivers/driver-shift';
import CreateDrivers from './pages/drivers/add';
import EditDrivers from './pages/drivers/Edit';
import Login from './pages/login';
import OrderDetails from './pages/orderDetails';
import OrderLogs from './pages/orderLogs';
import Fleets from './pages/fleets';
import PostOrders from './pages/orders/postOrderIndex';
import SendPostOrders from './pages/postOrders/add';
import PostPrintLabels from './pages/postOrders/printLabel/receipt';
import PostReceipts from './pages/postOrders/postReceipt/receipt';
import ParcelLogs from './pages/parcelLogs';
import Print3pl from './pages/orders/components/print3pl/receipt';
import PostList from './pages/orders/components/postList/receipt';
import PostOrderExitReceipt from './pages/postOrderQueue/components/exitRecipt';
import Pickup from './pages/pickup';
import PickupDetails from './pages/pickupDetails';
import assignPickup from './pages/assignPickup';
import NonOrderPostIndex from './pages/orders/nonOrderPostIndex';
import delivarInRonadIndex from './pages/orders/deliverInRonadIndex';
import NonPostOrderDetails from './pages/nonPostOrderDetails';
import PostOrder3PLDetails from './pages/postOrder3PLDetails';
import CreateBundle from './pages/createBundle';
import EditBundle from './pages/bundles/edit';
import VipOrders from './pages/orders/vipOrder';
import VVipOrders from './pages/orders/vvipOrder';
import AllOrders from './pages/orders/allOrdersIndex';
import GroupingCreate3PL from './pages/create3PL/groupingCreate';
import ExitReceipt from './pages/orderPack/components/exitRecipt';
import CreateBundleWithExcel from './pages/bundlewithexcel';
import ParcelReceipts from './components/Print/ParcelReceipt';

//Security Panel Routes
import SecurityPanel from './pages/securityPanel';
import SecurityActiveDrivers from './pages/securityPanel/activeDrivers'
import TrafficHistory from './pages/securityPanel/trafficHistory';
import ActiveDrivers from './pages/securityPanel/activeDrivers';
import { AddDriverEntrance } from './pages/securityPanel/addDriverEntrance';
import Profile from './pages/profile';
import DeliverToDriverReceipt from './components/Print/deliverToDriverReceipt';
import Ticketing from './pages/ticketing';
import TicketDetails from './pages/ticketDetail';
import Assignments from './pages/assignment';

export type Routes = RouteInterface[];
export type RouteInterface = {
  component: Function;
  path: string;
  routes?: string;
};

// Const routes
export const routes: Routes = [
  {
    path: '/security/add-driver',
    component: AddDriverEntrance,
  },
  {
    path: '/security/traffic-history',
    component: TrafficHistory,
  },
  {
    path: '/security/active-drivers',
    component: ActiveDrivers,
  },
  {
    path: '/security',
    component: SecurityPanel,
  },
  {
    path: '/orders/post/exit-receipts',
    component: PostOrderExitReceipt,
    //wos
  },
  {
    path: '/login',
    component: Login,
    //wos
  },
  {
    path: '/profile',
    component: Profile,
  },
  {
    path: '/vip-orders',
    component: VipOrders,
  },
  {
    path: '/vvip-orders',
    component: VVipOrders,
  },
  {
    path: '/all-orders',
    component: AllOrders,
  },
  {
    path: '/vip-orders/3pl-orders/:id',
    component: PostOrder3PLDetails,
  },
  {
    path: '/deliver-ronad-orders',
    component: delivarInRonadIndex,
  },
  {
    path: '/nonPost-orders',
    component: NonOrderPostIndex,
  },
  {
    path: '/nonPost-orders/:id',
    component: NonPostOrderDetails,
  },
  {
    path: '/post-orders',
    component: PostOrders,
  },
  {
    path: '/post-print-labels/:id',
    component: PostPrintLabels,
    //wos
  },
  {
    path: '/pickups',
    component: Pickup,
  },
  {
    path: '/post-orders/:id/send',
    component: SendPostOrders,
  },
  {
    path: '/post-orders/post-receipt',
    component: PostReceipts,
    //wos
  },
  {
    path: '/orders/exit-receipts/:id',
    component: ExitReceipt,
  },
  {
    path: '/orders/:id',
    component: OrderDetails,
  },
  {
    path: '/orders/:id/allLogs',
    component: OrderLogs,
  },
  {
    path: '/3pl-print-labels',
    component: Print3pl,
  },
  {
    path: '/post-list',
    component: PostList,
  },
  {
    path: '/nonPost-orders/3pl-orders/:id',
    component: PostOrder3PLDetails,
  },
  {
    path: '/create-grouping-3PL',
    component: GroupingCreate3PL,
  },
  {
    path: '/pickups/details/:id',
    component: PickupDetails,
  },
  {
    path: '/pickups/details/receipt/:id',
    component: ParcelReceipts,
  },
  {
    path: '/parcels/:id/allLogs',
    component: ParcelLogs,
  },
  {
    path: '/pickups/assignment/:id',
    component: assignPickup,
  },
  {
    path: '/fleets/:id/drivers',
    component: Drivers,
  },
  {
    path: '/fleets',
    component: Fleets,
  },
  {
    path: '/drivers',
    component: Drivers,
  },
  {
    path: '/bundles',
    component: Bundles,
  },
  {
    path: '/bundles/:id',
    component: BundleDetails,
  },
  {
    path: '/bundles/:id/allLogs',
    component: bundleLogs,
  },
  {
    path: '/create-bundle',
    component: CreateBundle,
  },
  {
    path: '/create-bundle-with-excel',
    component: CreateBundleWithExcel,
  },
  {
    path: '/edit-bundle/:id',
    component: EditBundle,
  },
  {
    path: '/fleets/:id/drivers/create',
    component: CreateDrivers,
  },
  {
    path: '/fleets/:fleetId/drivers/:id/edit',
    component: EditDrivers,
  },
  {
    path: '/drivers/:id/shifts/:shiftId',
    component: DriversShift,
  },
  {
    path: '/assignments',
    component: Assignments,
  },
  {
    path: '/ticketing',
    component: Ticketing,
    //wos
    //bemoon
  },
  {
    path: '/ticketing/:id',
    component: TicketDetails,
    //wos
    //bemoon
  },
  { path:'/deliver-driver-receipt/:id',
    component: DeliverToDriverReceipt,}
];
const Referee = () => {
  const { pathname } = useLocation();
  const filters: string[] = [
    '/login',
    '/post-orders/receipts/',
    '/orders/receipts/',
    '/orders/exit-receipts/',
    '/orders/post/exit-receipts',
    // '/orders/receipt/bulk',
    '/products/',
    '/parcels/receipts/',
    '/print-labels/',
    '/post-print-labels/',
    '/post-orders/post-receipt',
    '/deliver-driver-receipt',
    '/security',
    '/3pl-print-labels',
    '/post-list',
    '/pickups/details/receipt'
  ];

  const wosidebare = filters.filter(route => {
    return pathname.includes(route);
  });
  return (
    <Fragment>
      <Switch>
        {wosidebare[0] == undefined ? (
          <Route path="/" component={Ws} />
        ) : (
          <Route path="/" component={Wos} />
        )}
      </Switch>
    </Fragment>
  );
};

export default withRouter(Referee);
const checkAuth = () => localStorage.getItem('token') !== null;
// A special wrapper for <Route> that knows how to
// handle "sub"-routes by passing them in a `routes`
// prop to the component it renders.
export function RouteWithSubRoutes(route: RouteInterface) {
  const authContext = useContext(AuthContext);
  return (
    <Can
      role={authContext.user.role}
      perform={route.path}
      yes={() => (
        <Route
          exact
          path={route.path}
          render={props => {
            if (!checkAuth()) {
              window.location.reload();
              // eslint-disable-next-line react/prop-types
              props.history.push('/login');
            }
            return <route.component {...props} routes={route.routes} />;
          }}
        />
      )}
    />
  );
}
